module.exports = __webpack_public_path__ + "img/4_uk.0cc0bdca.svg";